import "./SoftwareFactorySection.css";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLocale } from "@/i18n/useLocale";
import { SOLUTION_PREFIX } from "@/i18n/config";
import SectionCta from "@/components/SectionCta/SectionCta";
import SolutionLink from "@/components/SolutionLink/SolutionLink";

import {
  mockDesktopBooking,
  mockMobileAI1,
  mockMobileAI2,
} from "@/assets";

function SoftwareFactorySection() {
  const { t, locale } = useLocale();
  const textRef = useScrollReveal<HTMLDivElement>();
  const mockupsRef = useScrollReveal<HTMLDivElement>({ delay: 120 });
  const footerRef = useScrollReveal<HTMLDivElement>({ delay: 200 });

  return (
    <section className="software-factory-section" id="software-factory">

      <div className="software-factory-section__content">
        <div className="software-factory-section__main">
          <div className="software-factory-section__left reveal--from-left" ref={textRef}>
            <span className="software-factory-section__badge">{t.software.badge}</span>

            <h2 className="software-factory-section__title">{t.software.title}</h2>

            <p className="software-factory-section__description">{t.software.p1}</p>

            <p className="software-factory-section__description">{t.software.p2}</p>

            {/* La landing de solucion -la money page- recibe de aca su enlace
                interno desde el cuerpo de la home, como tarjeta y pegada al
                texto para que no se pierda. */}
            <SolutionLink
              to={`${SOLUTION_PREFIX[locale]}/desarrollo-software-a-medida`}
              label={t.software.solutionLink}
              kicker={t.solutionCard.kicker}
              variant="software"
            />
          </div>

          <div className="software-factory-section__right reveal--zoom" ref={mockupsRef}>
            <div className="software-factory-section__mockups mockups">
              <img
                loading="lazy"
                src={mockDesktopBooking}
                alt="Sitio web en desktop" title="Sitio web en desktop"
                className="mockup software-factory-section__mockup software-factory-section__mockup--desktop"
              />

              <img
                loading="lazy"
                src={mockMobileAI1}
                alt="Selección de síntomas en la app de atención médica de Grupo Emerger" title="Selección de síntomas en la app de atención médica de Grupo Emerger"
                className="mockup software-factory-section__mockup software-factory-section__mockup--mobile-1"
              />

              <img
                loading="lazy"
                src={mockMobileAI2}
                alt="Pantalla de contacto y emergencias de la app de Grupo Emerger" title="Pantalla de contacto y emergencias de la app de Grupo Emerger"
                className="mockup software-factory-section__mockup software-factory-section__mockup--mobile-2"
              />
            </div>
          </div>
        </div>

        <div className="software-factory-section__footer" ref={footerRef}>
          <SectionCta
            label={t.sectionCta.software}
            variant="software"
          />
        </div>
      </div>
    </section>
  );
}

export default SoftwareFactorySection;
